import createReducer from '../utils/createReducer';
import {
  PROJECT_MAPPINGS_REQUEST,
  PROJECT_MAPPINGS_FAILURE,
  PROJECT_MAPPINGS_SUCCESS,

} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [PROJECT_MAPPINGS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [PROJECT_MAPPINGS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [PROJECT_MAPPINGS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/projectMappings.js